import { CommonService } from '../../shared/services/common.service';
import { UserTitleType } from '../../shared/enums/user-title-type.enum';
import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Member } from '../../shared/interfaces/member.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { MemberLevel } from '../../shared/enums/member-level.enum';
import { ActiveSessionService } from '../../shared/services/active-session.service';
import { MemberType } from '../../shared/enums/member-type.enum';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-price-popover',
    templateUrl:
        '../templates/template1/views/price-popover.component.html',
    styleUrls: [
        '../templates/template1/themes/less/price-popover.component.less'
    ],
    encapsulation: ViewEncapsulation.None
})
export class PricePopoverComponent implements OnInit {
    @Input() product: any;
    @Input() memberTitleId: MemberLevel;
    memberTitle = MemberLevel;
    discountPercenatge = 0;
    userInfo: Member;
    wholesaleQualified: boolean;
    translationValues: any;
    @Input() container = 'body';
    @Input() customClass = '';
    optin: boolean;
    enableWHLSAL00ForAsstSupervisor: boolean;
    constructor(private _commonService: CommonService,
        private _cacheService: CacheService,
        private _activeSessionService: ActiveSessionService) {

    }

    ngOnInit() {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        if (this.userInfo && this.userInfo.memberTitle) {
            this.translationValues = {
                memberTitle: this.userInfo.memberTitle.toLowerCase()
            };
            this.memberTitleId = this.userInfo.memberTitleId;
            this.wholesaleQualified = this.userInfo.transactionalWholesaleQualified ? this.userInfo.transactionalWholesaleQualified : false;
            this.optin = this.userInfo.transactionalOptin ? this.userInfo.transactionalOptin : false;
        }
        if (!this.memberTitleId) {
            this.memberTitleId = MemberLevel.RETAIL;
        }
        if (this.userInfo && this.userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER) {
            this.memberTitleId = MemberLevel.PREFERREDCUSTOMER;
        }
        this.discountPercenatge = this._commonService.getDiscountPerc();
        this.customClass += ' price-popover';
        const enableWHLSAL00ForAsstSupervisor = this._commonService.getEnableWHLSALForAsstSupervisor();
        this.enableWHLSAL00ForAsstSupervisor = (this.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
            || (this.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR && !enableWHLSAL00ForAsstSupervisor))
        ? false : true;
    }

    /**
     * @returns number
     */
    getTotalSavings(product: any): number {
        return this._commonService.totalSavingsCalc(product, this.memberTitleId, this.wholesaleQualified, this.optin);
    }

    focusPopOver(popTemplate: any, showhide: any) {
        if (showhide) {
            document.getElementById('popTemplate').focus();
        }

    }
}
